import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

const CardPreviewCell = ({ card, onHover, onLeave, onClick }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box
            onMouseEnter={onHover ? (e) => onHover(card, e) : undefined}
            onMouseLeave={onLeave || undefined}
            onClick={onClick}
            sx={{
                width: 'fit-content',
                height: 'fit-content',
                margin: '0 auto',
                borderRadius: '8px',
                border: '2px solid rgba(76, 29, 149, 0.3)',
                transition: 'all 0.3s ease',
                cursor: onClick ? 'pointer' : 'default',
                '&:hover': {
                    border: '2px solid rgba(76, 29, 149, 0.6)',
                    transform: onClick ? 'scale(1.05)' : 'none'
                }
            }}
        >
            {card.image_urls && card.image_urls.length > 0 ? (
                <img
                    src={card.image_urls[0].url}
                    alt={card.name}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                    }}
                />
            ) : (
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        background: 'linear-gradient(135deg, rgba(76, 29, 149, 0.2), rgba(139, 92, 246, 0.2))',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '2px dashed rgba(76, 29, 149, 0.3)'
                    }}
                >
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }}>
                        No image
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default CardPreviewCell; 